// build: fall 2026 seo
import "./index.css";
import React from "react";
import { render } from "react-dom";
import { App } from "./App";
render(<App data-id="element-98" data-mp="1wc5vo5p3mulc" />, document.getElementById("root"));